// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import {get, without} from 'lodash';

type Value = number|string;
export default (name: string, triggerValidation: boolean = true) => {
	const {getValues, setValue} = useFormContext();
	const selectedValues = get(getValues({nest: true}), name, []);

	return (value: Value) => setValue(
		name,
		selectedValues.includes(value) ?
			without(selectedValues, value) :
			selectedValues.concat(value),
		triggerValidation
	);
}
